import { useState } from "react";
import bebgoroVeidos from "./videos";
import Image from "next/image";

const DesktopVideoPlayList = () => {
  const [active, setActiveVideo] = useState(bebgoroVeidos[0]);
  return (
    <div className=" lg:w-3/4 md:w-9/10 place-self-center mt-4 flex-row rounded-xl md:visible md:flex hidden bg-[#0b44e0cb]">
      <div className="flex-4 m-6 mb-3 rounded-xl overflow-hidden">
        <iframe src={active.iframe} allowFullScreen className="w-full aspect-video rounded-[12px]" />

        {/* <div className=" z-100 w-full text-right text-2xl mt-2 pr-2 text-gray-800 flex flex-row-reverse content-end items-center gap-1">
          <p className="text-2xl">🛈</p>
          فصل فلانم
        </div> */}
      </div>
      <div className="flex-1 aspect-9/4 rounded-xl  overflow-auto">
        <div className="w-full gap-3 p-3  flex flex-col ">
          {bebgoroVeidos.map(({ iframe, img }, i) => (
            <Image
              onClick={() => setActiveVideo({ iframe, img })}
              key={i}
              className="w-full aspect-video object-cover rounded-xl overflow-hidden cursor-pointer"
              src={img}
              alt=""
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DesktopVideoPlayList;
